module.exports = __webpack_public_path__ + "img/company1.6f5364c3.png";